/** S API BaseURL **/
const baseURLMap = {
	// 开发环境 
	development: 'https://proapi.zyxbzz.com',
	// development: 'http://192.168.0.175:2834',
	// 生产环境
	production: 'https://proapi.zyxbzz.com',
	// production: 'http://192.168.0.175:2834',
}
const baseURL = baseURLMap[process.env.NODE_ENV]

const HEADER = {
	'content-type': 'application/json'
};
const webUrlMap = {
	// 开发环境 
	development: 'https://proapi.zyxbzz.com/',
	// // 生产环境
	production: 'https://proapi.zyxbzz.com/',
	// 开发环境
	// development: 'http://192.168.0.175:2834/',
	// 生产环境
	// production: 'http://192.168.0.175:2834/',
}
const webUrl = webUrlMap[process.env.NODE_ENV]
const statusName = 'code' //请求状态KEY
export {
	HEADER,
	statusName,
	baseURL,
	webUrl
}